// extracted by mini-css-extract-plugin
export default {"wrapper":"rBEjbLxd","pill":"wqT8QxLH","inputInnerWrapper":"PyFxnyP8","input":"niDigUw0","inputButton":"yMabCeOX","sendButton":"h0ARBlhF"};